import React, { useState } from 'react';
import '../../Header/JobLoadsManagementHeader/JobLoadsManagementHeader.scss';

import { useAuthContext } from '../../Auth/AuthProvider';
import { PermissionEnum } from '../../../types/PermissionEnum';
import { useStoreContext } from '../../App/StoreProvider';
import './Inventory.scss';
import { Alert, Dropdown, OverlayTrigger, Table } from 'react-bootstrap';
import { GET_BOXES, GET_SET_UP, GET_STAGE_SHEET_PROP } from '../../../graphql/client/queries';
import { useMutation, useQuery } from '@apollo/client/react';
import { Error, Loading } from '../../_common';
import {
    GetBoxes,
    GetBoxes_getBoxes_boxDetails as BoxDetails,
    BoxDetailsToAddBoxesProps,
    GetSetup,
    GetStageSheetProp,
    GetStageSheetProp_getStageSheetProp as StageSheetPropType,
} from '../../../types/schemaTypes';
// import {NumericFormat as NumberFormat} from 'react-number-format';
import { NumericFormat as NumberFormat } from 'react-number-format';

import { ToastContainer, toast } from 'react-toastify';
import { toastOpt } from '../../../utils/helpers/toastHelper'
import { Link, useParams } from 'react-router-dom';
import { Routes } from '../../../utils';
import { ADD_BOXES } from '../../../graphql/client/mutations';
import JobMenuItems from '../../Header/JobMenuItemsHeader/JobMenuItems';

interface InventoryDataProps {
    rowName: string;
    b: BoxDetails[];
    t: BoxDetails[];
}

interface ProppantWeightProps {
    proppantId: number;
    proppant: string;
    weight: number;
    totalWeight: number;
}

const AddBoxes = ({ match }: any): React.ReactElement => {
    const authContext = useAuthContext();
    const [state, dispatch] = useStoreContext();
    const [tabTitle, setTabTitle] = useState(document.title);
    document.title = localStorage.getItem('Jobdetails-TabName') + '';
    const abortController = new AbortController();

    const isAddBoxesEnabled = authContext.userHasPermission(PermissionEnum.AddBoxes);
    const isDisplayLoadsEnabled = authContext.userHasPermission(PermissionEnum.ViewLoads);

    const [boxDetails, setBoxDetails] = useState<BoxDetailsToAddBoxesProps[]>([]);
    const [proppantWeightsList, setProppantWeightsList] = useState<ProppantWeightProps[]>([]);
    const [isSaveDiabled, setIsSaveDiabled] = useState(true);

    const toasterOptions = { duration: 4500 };
    const { jobId, stageSheetId } = useParams()
    const jobIdVal: any = jobId;
    const stageSheetIdVal: any = stageSheetId;

    const renderToast = (message, type = 'info') => {
        interface ToastProps {
            onClose?: () => void;
        }
        const Comp = (props: ToastProps) => {
            return (
                <Alert variant={type} onClose={props.onClose}>
                    {message}
                </Alert>
            );
        };

        Comp.displayName = 'toast';
        return Comp;
    };

    const { loading: getSetUpLoading, error: getSetupError, data: setupData } = useQuery<GetSetup>(GET_SET_UP, {
        variables: {
            jobId: parseInt(jobIdVal),
        },
        fetchPolicy: 'network-only',
    });
    let rowCount = 0;
    let columnCount = 0;
    if (setupData && setupData.getSetup) {
        rowCount = setupData.getSetup.rowCount ?? 0;
        columnCount = setupData.getSetup.columnCount ?? 0;
    }
    const columnNames: number[] = [];
    for (let i = 0; i < columnCount; i++) {
        columnNames.push(i + 1);
    }

    const { loading: proppantsLoading, error: proppantsError, data: proppantsData } = useQuery<GetStageSheetProp>(
        GET_STAGE_SHEET_PROP,
        {
            variables: {
                stageSheetId: parseInt(stageSheetIdVal),
            },
            fetchPolicy: 'network-only',
        },
    );

    const proppantDetails: StageSheetPropType[] = [];
    if (proppantsData && proppantsData.getStageSheetProp) {
        proppantsData.getStageSheetProp.map(prop => {
            if (prop) proppantDetails.push(prop);
        });
    }

    const { loading: getBoxesLoading, error: getBoxesError, data: boxesData } = useQuery<GetBoxes>(GET_BOXES, {
        variables: {
            jobId: parseInt(jobIdVal),
        },
        fetchPolicy: 'network-only',
    });

    const handleOnCompleteMutation = () => {
        (document.getElementsByClassName('Add-Boxes-Back-Button')[0] as HTMLAnchorElement).click();
        toast.success('Added Boxes successfully', toastOpt);
        setBoxDetails([]);
    };

    const handleOnError = (errorMessage: string) => {
        toast.error(`Failed to Add Boxes - ${errorMessage}`, toastOpt);

    };

    const [addBoxes, { loading: mutationLoading }] = useMutation(ADD_BOXES, {
        onCompleted: () => handleOnCompleteMutation(),
        onError: error => handleOnError(error.message.replace('GraphQL error:', '')),
    });

    const handleOnSave = async () => {
        if (boxDetails.length > 0) {
            setIsSaveDiabled(true);
            await addBoxes({
                variables: {
                    input: {
                        stageSheetId: parseInt(stageSheetIdVal),
                        boxDetails: boxDetails,
                    },
                },
            });
        }
    };

    const checkIfCurrentStageSheet = stageSheetId => {
        let isCurrentStageSheet = false;
        stageSheetId.split(',').map(stageSheetId => {
            if (parseInt(stageSheetId) === parseInt(stageSheetIdVal)) isCurrentStageSheet = true;
        });
        return isCurrentStageSheet;
    };

    const onClickBox = (boxId, loadId, proppantId, proppant, weight, row, column, level) => {
        document.getElementById(`${row}-${column}-${level}`)?.classList.add('Inventory-Box-Selected');

        const tempBoxDetails = boxDetails;
        let exists = false;
        tempBoxDetails.map(boxDetail => {
            if (boxDetail.boxId === boxId) exists = true;
        });
        if (exists) return;
        tempBoxDetails.push({
            boxId: boxId,
            loadId: loadId,
            proppantId: proppantId,
            weight: weight,
            row: row,
            column: column,
            level: level,
        });
        setBoxDetails(tempBoxDetails);

        const tempProppantWeightsList = proppantWeightsList.slice();
        let proppantWeightExists = false;
        tempProppantWeightsList.map(proppantWeight => {
            if (proppantWeight.proppantId === proppantId) {
                proppantWeightExists = true;
                proppantWeight.weight = proppantWeight.weight + weight;
            }
        });
        if (!proppantWeightExists) {
            let totalWeightNeeded = 0;
            let totalBoxWeight = 0;
            proppantDetails.map(prop => {
                if (prop.proppantName === proppant) {
                    totalBoxWeight = prop.totalBoxWeight ?? 0;
                    totalWeightNeeded = prop.totalWeightNeeded ?? 0;
                }
            });
            tempProppantWeightsList.push({
                proppantId: proppantId,
                proppant: proppant,
                weight: weight + totalBoxWeight,
                totalWeight: totalWeightNeeded,
            });
        }
        setProppantWeightsList(tempProppantWeightsList);

        if (tempBoxDetails.length === 0) setIsSaveDiabled(true);
        else setIsSaveDiabled(false);
    };

    const onDoubleClickBox = (boxId, proppantId, weight, row, column, level) => {
        document.getElementById(`${row}-${column}-${level}`)?.classList.remove('Inventory-Box-Selected');

        const tempBoxDetails = boxDetails;
        let boxIndex = -1;
        tempBoxDetails.map((boxDetail, index) => {
            if (boxDetail.boxId === boxId) {
                boxIndex = index;
            }
        });
        if (boxIndex !== -1) {
            tempBoxDetails.splice(boxIndex, 1);
            setBoxDetails(tempBoxDetails);
        }

        const tempProppantWeightsList = proppantWeightsList.slice();
        let proppantWeightIndex = -1;
        tempProppantWeightsList.map((proppantWeight, index) => {
            if (proppantWeight.proppantId === proppantId) {
                proppantWeightIndex = index;
                proppantWeight.weight = proppantWeight.weight - weight;
            }
        });
        setProppantWeightsList(tempProppantWeightsList);

        if (tempBoxDetails.length === 0) setIsSaveDiabled(true);
        else setIsSaveDiabled(false);
    };

    const proppantLegends: { title: string; color: string }[] = [];
    if (boxesData && boxesData.getBoxes && boxesData.getBoxes.proppantColors) {
        boxesData.getBoxes.proppantColors.forEach(proppantColorItem => {
            if (proppantColorItem) {
                proppantLegends.push({
                    title: proppantColorItem.descrip ?? '',
                    color: proppantColorItem.color ?? '',
                });
            }
        });
    }

    const inventoryData: InventoryDataProps[] = [];
    const unassignedInventory: BoxDetails[] = [];
    const outOfService: BoxDetails[] = [];
    const emptyBoxes: string[] = [];
    let jobName = '';

    let isBellyDump = false;
    
    if (boxesData && boxesData.getBoxes && boxesData.getBoxes.boxDetails) {
        jobName = boxesData.getBoxes.wellName ?? '';
        isBellyDump = boxesData.getBoxes.isBellyDump ?? false;
        if (rowCount > 0) {
            let rowName = 'A';
            for (let i = 0; i < rowCount; i++) {
                inventoryData.push({
                    rowName: rowName,
                    b: new Array(columnCount).fill(-1),
                    t: new Array(columnCount).fill(-1),
                });
                rowName = String.fromCharCode(rowName.charCodeAt(0) + 1);
            }
        }

        if (boxesData.getBoxes.boxDetails.length > 0) {
            const tempProppantWeightsList = proppantWeightsList.slice();
            boxesData.getBoxes.boxDetails.forEach(boxDetail => {
                if (!boxDetail) return;
                if (proppantWeightsList.length === 0) {
                    let proppantWeightExists = false;
                    tempProppantWeightsList.map(proppantWeight => {
                        if (proppantWeight.proppantId === boxDetail.proppantId) {
                            proppantWeightExists = true;
                        }
                    });

                    if (!proppantWeightExists) {
                        let totalWeightNeeded = 0;
                        let totalBoxWeight = 0;
                        proppantDetails.map(prop => {
                            if (prop.proppantName === boxDetail.proppantDesc) {
                                totalBoxWeight = prop.totalBoxWeight ?? 0;
                                totalWeightNeeded = (prop.totalBoxWeight ?? 0) + (prop.totalWeightNeeded ?? 0);
                            }
                        });
                        tempProppantWeightsList.push({
                            proppantId: boxDetail.proppantId ?? 0,
                            proppant: boxDetail.proppantDesc ?? '',
                            weight: totalBoxWeight,
                            totalWeight: totalWeightNeeded,
                        });
                    }
                }

                if (boxDetail.queueDesc === 'Assigned' && rowCount > 0 && columnCount > 0) {
                    const rowId = boxDetail.rowId ?? 0;
                    const columnId = boxDetail.columnId ?? 0;
                    const index = rowId - 1;

                    inventoryData[index].rowName = boxDetail.row ?? '';
                    if (boxDetail.level === 'Top') {
                        inventoryData[index].t[columnId - 1] = boxDetail;
                    }
                    if (boxDetail.level === 'Bottom') {
                        inventoryData[index].b[columnId - 1] = boxDetail;
                    }
                }

                if (boxDetail && boxDetail.queueDesc === 'UnAssigned') {
                    unassignedInventory.push(boxDetail);
                }

                if (boxDetail && boxDetail.queueDesc === 'DoNotUse' && boxDetail.boxDesc) {
                    outOfService.push(boxDetail);
                }

                if (boxDetail && boxDetail.queueDesc === 'Empty' && boxDetail.boxDesc) {
                    emptyBoxes.push(boxDetail.boxDesc);
                }
            });

            if (proppantWeightsList.length === 0) setProppantWeightsList(tempProppantWeightsList);
        }
    }

    if (!isAddBoxesEnabled) {
        return (
            <div className="Inventory-Container">
                <ToastContainer />
                <div className="Inventory-Header-Container">
                    <div className="Inventory-Header-Text">On Site Inventory: {jobName}</div>

                    <JobMenuItems jobId={jobId ?? "0"} menu='inventory'/>
                </div>

                <div className="NoResult-Container Inventory-Unauth-Container">
                    <div className="NoResult-First-Title-Secondary">Unauthorized</div>
                    <div className="NoResult-First-Title-Primary">You do not have permission to view this screen</div>
                </div>
            </div>
        );
    }

    if (setupData && setupData.getSetup && setupData.getSetup.rowCount === 0 && setupData.getSetup.columnCount === 0) {
        return (
            <div className="Inventory-Container">
                <ToastContainer />
                <div className="Inventory-Header-Container">
                    <div className="Inventory-Header-Text">Add Boxes: {jobName}</div>

                    <JobMenuItems jobId={jobId ?? "0"} menu='inventory'/>

                </div>

                <div className="Inventory-Tab-Actions-Container">
                    <div className="Inventory-Sub-Header Add-Boxes-Buttons">
                    {isBellyDump ?
                        (<Link
                            to={{
                                pathname: `${Routes.STAGE_SHEET_BELLY_DUMP.route}${stageSheetIdVal}`,
                            }}
                            className="Add-Boxes-Back-Button"
                        >
                            Back
                        </Link>) :
                        (<Link
                            to={{
                                pathname: `${Routes.STAGE_SHEET.route}${stageSheetIdVal}`,
                            }}
                            className="Add-Boxes-Back-Button"
                        >
                            Back
                        </Link>) 
                    }
                    </div>
                </div>

                <div className="NoResult-First-Title-Primary">
                    Inventory configuration is not available. Kindly set up the inventory.
                </div>
            </div>
        );
    }

    return (
        <div className="Inventory-Container">
            <ToastContainer />
            <div className="Inventory-Header-Container">
                <div className="Inventory-Header-Text">Add Boxes: {jobName}</div>

                <JobMenuItems jobId={jobId ?? "0"} menu='inventory'/>
            </div>

            <div className="Inventory-Tab-Actions-Container">
                <div className="Inventory-Sub-Header Add-Boxes-Buttons">
                {isBellyDump ?
                    (<Link
                        to={{
                            pathname: `${Routes.STAGE_SHEET_BELLY_DUMP.route}${stageSheetIdVal}`,
                        }}
                         className="Add-Boxes-Back-Button"
                    >
                        Back
                    </Link>) :
                    (<Link
                        to={{
                            pathname: `${Routes.STAGE_SHEET.route}${stageSheetIdVal}`,
                        }}
                         className="Add-Boxes-Back-Button"
                    >
                        Back
                    </Link>) 
                }
                    <button
                        className={`${isSaveDiabled ? 'Add-Boxes-Save-Button-Disabled' : 'Add-Boxes-Save-Button'}`}
                        onClick={handleOnSave}
                        disabled={isSaveDiabled}
                    >
                        Save
                    </button>
                </div>
            </div>

            {getSetUpLoading || getBoxesLoading ? (
                <div className="Inventory-Spinner-Container">
                    <Loading />
                </div>
            ) : (
                <div className="Inventory-Table-Container">
                    {getSetupError && (
                        <div className="Inventory-Error">
                            <Error error={getSetupError} />
                        </div>
                    )}
                    {getBoxesError && (
                        <div className="Inventory-Error">
                            <Error error={getBoxesError} />
                        </div>
                    )}
                    {!getSetupError && !getBoxesError && (
                        <Table className="tables Inventory-Table" bordered>
                            <thead className="Inventory-Table-Header">
                                <tr>
                                    <th className="Inventory-Column Inventory-LeftBorder" colSpan={2}></th>
                                    {columnNames.map((columnName, index) => (
                                        <th
                                            className={`${index === columnNames.length - 1
                                                    ? 'Inventory-Column Inventory-RightBorder'
                                                    : 'Inventory-Column'
                                                }`}
                                            key={index}
                                        >
                                            {columnName}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {mutationLoading && (
                                    <div className="AddBox-Spinner-Container">
                                        <Loading />
                                    </div>
                                )}
                                {inventoryData &&
                                    inventoryData.map((inventoryDataItem, rowIndex) => (
                                        <>
                                            <tr key={rowIndex}>
                                                <th rowSpan={2} className="Inventory-Row">
                                                    {inventoryDataItem.rowName}
                                                </th>
                                                <td className="Inventory-BT Inventory-BottomBorder">B</td>
                                                {inventoryDataItem.b.map((boxDetail, index) =>
                                                    boxDetail.boxDesc ? (
                                                        <OverlayTrigger
                                                            key={index}
                                                            placement="top"
                                                            delay={{ show: 250, hide: 400 }}
                                                            overlay={
                                                                <div className="Inventory-Tooltip">
                                                                    <div>
                                                                        Remaining Weight: &nbsp;
                                                                        <NumberFormat
                                                                            value={boxDetail.currentProppantWeight || 0}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        Unallocated Weight: &nbsp;
                                                                        <NumberFormat
                                                                            value={boxDetail.weightRemaining || 0}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                        >
                                                            <td
                                                                className={`Inventory-Not-Draggable Inventory-BottomBorder ${!checkIfCurrentStageSheet(
                                                                    boxDetail.stageSheetId,
                                                                ) &&
                                                                    (boxDetail.stageSheetProppantId === '0' ||
                                                                        (boxDetail.weightRemaining &&
                                                                            boxDetail.weightRemaining > 0)) &&
                                                                    'Inventory-AddBox'}`}
                                                                id={`${boxDetail.row}-${boxDetail.column}-${boxDetail.level}`}
                                                                style={{
                                                                    background: `linear-gradient(to right, 
                                                                            ${boxDetail.proppantColor}
                                                                            ${boxDetail.fillPerc}%, 
                                                                            #f8f8f8 ${boxDetail.fillPerc}%)`,
                                                                }}
                                                                onClick={() => {
                                                                    if (
                                                                        !checkIfCurrentStageSheet(
                                                                            boxDetail.stageSheetId,
                                                                        ) &&
                                                                        (boxDetail.stageSheetProppantId === '0' ||
                                                                            (boxDetail.weightRemaining &&
                                                                                boxDetail.weightRemaining > 0))
                                                                    )
                                                                        onClickBox(
                                                                            boxDetail.boxId,
                                                                            boxDetail.loadId,
                                                                            boxDetail.proppantId,
                                                                            boxDetail.proppantDesc,
                                                                            boxDetail.weightRemaining,
                                                                            boxDetail.row,
                                                                            boxDetail.column,
                                                                            boxDetail.level,
                                                                        );
                                                                }}
                                                                onDoubleClick={() => {
                                                                    if (
                                                                        !checkIfCurrentStageSheet(
                                                                            boxDetail.stageSheetId,
                                                                        ) &&
                                                                        (boxDetail.stageSheetProppantId === '0' ||
                                                                            (boxDetail.weightRemaining &&
                                                                                boxDetail.weightRemaining > 0))
                                                                    )
                                                                        onDoubleClickBox(
                                                                            boxDetail.boxId,
                                                                            boxDetail.proppantId,
                                                                            boxDetail.weightRemaining,
                                                                            boxDetail.row,
                                                                            boxDetail.column,
                                                                            boxDetail.level,
                                                                        );
                                                                }}
                                                            >
                                                                {checkIfCurrentStageSheet(boxDetail.stageSheetId) ||
                                                                    (boxDetail.stageSheetProppantId !== '0' &&
                                                                        boxDetail.weightRemaining === 0) ? (
                                                                    <div className="AddBoxes-Crossed">
                                                                        {boxDetail.boxDesc}
                                                                        {checkIfCurrentStageSheet(
                                                                            boxDetail.stageSheetId,
                                                                        ) && <div className="AddBoxes-Current" />}
                                                                    </div>
                                                                ) : (
                                                                    boxDetail.boxDesc
                                                                )}
                                                            </td>
                                                        </OverlayTrigger>
                                                    ) : (
                                                        <td
                                                            key={index}
                                                            id={`${boxDetail.row}-${boxDetail.column}-${boxDetail.level}`}
                                                            className="Inventory-Not-Draggable Inventory-BottomBorder"
                                                        >
                                                            {boxDetail.boxDesc}
                                                        </td>
                                                    ),
                                                )}
                                            </tr>
                                            <tr>
                                                <td className="Inventory-BT Inventory-TopBorder">T</td>
                                                {inventoryDataItem.t.map((boxDetail, index) =>
                                                    boxDetail.boxDesc ? (
                                                        <OverlayTrigger
                                                            key={index}
                                                            placement="top"
                                                            delay={{ show: 250, hide: 400 }}
                                                            overlay={
                                                                <div className="Inventory-Tooltip">
                                                                    <div>
                                                                        Remaining Weight: &nbsp;
                                                                        <NumberFormat
                                                                            value={boxDetail.currentProppantWeight || 0}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        Unallocated Weight: &nbsp;
                                                                        <NumberFormat
                                                                            value={boxDetail.weightRemaining || 0}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                        >
                                                            <td
                                                                id={`${boxDetail.row}-${boxDetail.column}-${boxDetail.level}`}
                                                                className={`Inventory-Not-Draggable Inventory-TopBorder ${!checkIfCurrentStageSheet(
                                                                    boxDetail.stageSheetId,
                                                                ) &&
                                                                    (boxDetail.stageSheetProppantId === '0' ||
                                                                        (boxDetail.weightRemaining &&
                                                                            boxDetail.weightRemaining > 0)) &&
                                                                    'Inventory-AddBox'}`}
                                                                style={{
                                                                    background: `linear-gradient(to right, 
                                                                            ${boxDetail.proppantColor}
                                                                            ${boxDetail.fillPerc}%, 
                                                                            #f8f8f8 ${boxDetail.fillPerc}%)`,
                                                                }}
                                                                onClick={() => {
                                                                    if (
                                                                        !checkIfCurrentStageSheet(
                                                                            boxDetail.stageSheetId,
                                                                        ) &&
                                                                        (boxDetail.stageSheetProppantId === '0' ||
                                                                            (boxDetail.weightRemaining &&
                                                                                boxDetail.weightRemaining > 0))
                                                                    )
                                                                        onClickBox(
                                                                            boxDetail.boxId,
                                                                            boxDetail.loadId,
                                                                            boxDetail.proppantId,
                                                                            boxDetail.proppantDesc,
                                                                            boxDetail.weightRemaining,
                                                                            boxDetail.row,
                                                                            boxDetail.column,
                                                                            boxDetail.level,
                                                                        );
                                                                }}
                                                                onDoubleClick={() => {
                                                                    if (
                                                                        !checkIfCurrentStageSheet(
                                                                            boxDetail.stageSheetId,
                                                                        ) &&
                                                                        (boxDetail.stageSheetProppantId === '0' ||
                                                                            (boxDetail.weightRemaining &&
                                                                                boxDetail.weightRemaining > 0))
                                                                    )
                                                                        onDoubleClickBox(
                                                                            boxDetail.boxId,
                                                                            boxDetail.proppantId,
                                                                            boxDetail.weightRemaining,
                                                                            boxDetail.row,
                                                                            boxDetail.column,
                                                                            boxDetail.level,
                                                                        );
                                                                }}
                                                            >
                                                                {checkIfCurrentStageSheet(boxDetail.stageSheetId) ||
                                                                    (boxDetail.stageSheetProppantId !== '0' &&
                                                                        boxDetail.weightRemaining === 0) ? (
                                                                    <div className="AddBoxes-Crossed">
                                                                        {boxDetail.boxDesc}
                                                                        {checkIfCurrentStageSheet(
                                                                            boxDetail.stageSheetId,
                                                                        ) && <div className="AddBoxes-Current" />}
                                                                    </div>
                                                                ) : (
                                                                    boxDetail.boxDesc
                                                                )}
                                                            </td>
                                                        </OverlayTrigger>
                                                    ) : (
                                                        <td
                                                            key={index}
                                                            id={`${boxDetail.row}-${boxDetail.column}-${boxDetail.level}`}
                                                            className="Inventory-Not-Draggable Inventory-TopBorder"
                                                        >
                                                            {boxDetail.boxDesc}
                                                        </td>
                                                    ),
                                                )}
                                            </tr>
                                        </>
                                    ))}
                            </tbody>
                        </Table>
                    )}
                </div>
            )}

            <div className="Inventory-Legends-Weights-Container">
                <div className="Inventory-Legends-Container">
                    {proppantLegends.map((proppantLegend, index) => (
                        <div className="Inventory-Legend" key={index}>
                            <div
                                className="Inventory-Legend-Color"
                                style={{ backgroundColor: proppantLegend.color }}
                            ></div>
                            <div className="Inventory-Legend-Title">{proppantLegend.title}</div>
                        </div>
                    ))}
                </div>
                <div className="Inventory-Weights-Container">
                    {proppantWeightsList.map((proppantWeight, index) => (
                        <div className="Inventory-ProppantWeight" key={index}>
                            <div className="Inventory-ProppantWeight-Key">{proppantWeight.proppant}:</div>
                            <div className="Inventory-ProppantWeight-Value">
                                <NumberFormat
                                    value={proppantWeight.weight}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                />
                                &nbsp; of &nbsp;
                                <NumberFormat
                                    value={proppantWeight.totalWeight}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Table className="tables" bordered hover>
                <thead>
                    <tr>
                        <th rowSpan={4} colSpan={5} className="Inventory-Forklift-Section">
                            <i className="material-icons Inventory-ForkLift-Icon">arrow_upward</i>
                            Forklift
                        </th>
                    </tr>
                    <tr></tr>
                    <tr></tr>
                    <tr></tr>
                </thead>
            </Table>

            <div className="Inventory-TableCollection">
                <Table className="tables Inventory-TableCollection-Table" hover bordered>
                    <thead>
                        <tr className="Inventory-TableCollection-Header">
                            <th>Empty Box Inventory</th>
                        </tr>
                    </thead>
                    {getSetUpLoading || getBoxesLoading ? (
                        <div className="Inventory-Spinner-Container">
                            <Loading />
                        </div>
                    ) : (
                        <tbody className="Inventory-Table-Boxes">
                            {emptyBoxes &&
                                emptyBoxes.map((emptyBox, index) => (
                                    <tr className="Inventory-Table-Boxes-Item" key={index}>
                                        <td>{emptyBox}</td>
                                    </tr>
                                ))}
                        </tbody>
                    )}
                </Table>

                <Table className="tables Inventory-TableCollection-Table" hover bordered>
                    <thead className="Inventory-TableCollection-Header">
                        <tr>
                            <th>Out of Service</th>
                        </tr>
                    </thead>
                    {getSetUpLoading || getBoxesLoading ? (
                        <div className="Inventory-Spinner-Container">
                            <Loading />
                        </div>
                    ) : (
                        <tbody className="Inventory-Table-Boxes">
                            {outOfService.map((item, index) => (
                                <OverlayTrigger
                                    key={index}
                                    placement="top"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                        <div className="Inventory-Tooltip">
                                            <div>
                                                Remaining Weight: &nbsp;
                                                <NumberFormat
                                                    value={item.currentProppantWeight || 0}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                />
                                            </div>
                                            <div>
                                                Unallocated Weight: &nbsp;
                                                <NumberFormat
                                                    value={item.weightRemaining || 0}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                />
                                            </div>
                                        </div>
                                    }
                                >
                                    <tr className="Inventory-Table-Boxes-Item" key={index}>
                                        <td
                                            style={{
                                                background: `linear-gradient(to right, ${item.proppantColor} ${item.fillPerc}%, #f8f8f8 ${item.fillPerc}%)`,
                                            }}
                                        >
                                            {item.boxDesc}
                                        </td>
                                    </tr>
                                </OverlayTrigger>
                            ))}
                        </tbody>
                    )}
                </Table>

                <Table className="tables Inventory-TableCollection-Table" hover bordered>
                    <thead className="Inventory-TableCollection-Header">
                        <tr>
                            <th>Unassigned Inventory</th>
                        </tr>
                    </thead>
                    {getSetUpLoading || getBoxesLoading ? (
                        <div className="Inventory-Spinner-Container">
                            <Loading />
                        </div>
                    ) : (
                        <tbody className="Inventory-Table-Boxes">
                            {unassignedInventory.map((item, index) => (
                                <OverlayTrigger
                                    key={index}
                                    placement="top"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                        <div className="Inventory-Tooltip">
                                            <div>
                                                Remaining Weight: &nbsp;
                                                <NumberFormat
                                                    value={item.currentProppantWeight || 0}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                />
                                            </div>
                                            <div>
                                                Unallocated Weight: &nbsp;
                                                <NumberFormat
                                                    value={item.weightRemaining || 0}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                />
                                            </div>
                                        </div>
                                    }
                                >
                                    <tr
                                        className="Inventory-Table-Boxes-Item Inventory-Assigned-Not-Draggable"
                                        key={index}
                                    >
                                        <td
                                            style={{
                                                background: `linear-gradient(to right, ${item.proppantColor} ${item.fillPerc}%, #f8f8f8 ${item.fillPerc}%)`,
                                            }}
                                        >
                                            {item.boxDesc}
                                        </td>
                                    </tr>
                                </OverlayTrigger>
                            ))}
                        </tbody>
                    )}
                </Table>
            </div>
        </div>
    );
};

export default AddBoxes;
